import { isDiscordMode } from 'src/common/utils/discord';
import { discordPlayer } from './discordPlayer';
import { player as playerSingleton } from './player';

export const player = isDiscordMode()
  ? (discordPlayer as unknown as typeof playerSingleton & typeof discordPlayer)
  : playerSingleton;
